"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = exports.ZoneConfigCodec = void 0;
const euclid_1 = require("@reality/euclid");
const ChainBuilder_1 = require("@reality/messenger/lib/common/ChainBuilder");
const MessageDefinition_1 = __importDefault(require("@reality/messenger/lib/common/MessageDefinition"));
const t = __importStar(require("io-ts"));
exports.ZoneConfigCodec = t.array(t.type({
    zoneName: t.string,
    viewLocation: euclid_1.CoordinateCodec,
}));
exports.Messages = {
    UpdateZoneTopic: new MessageDefinition_1.default("UpdateZoneTopic", t.type({ zone: t.string, topic: t.string })),
    GetAllZoneTopics: new ChainBuilder_1.ChainBuilder("GetAllZoneTopics")
        .clientSends(t.type({ zones: t.array(t.string) }))
        .serverSends(t.record(t.string, t.string))
        .end(),
    SetZoneTopic: new MessageDefinition_1.default("SetZoneTopic", t.type({ zone: t.string, topic: t.string })),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbW1vbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNENBQWtEO0FBQ2xELDZFQUEwRTtBQUMxRSx3R0FBZ0Y7QUFDaEYseUNBQTJCO0FBRWQsUUFBQSxlQUFlLEdBQUcsQ0FBQyxDQUFDLEtBQUssQ0FDcEMsQ0FBQyxDQUFDLElBQUksQ0FBQztJQUNMLFFBQVEsRUFBRSxDQUFDLENBQUMsTUFBTTtJQUNsQixZQUFZLEVBQUUsd0JBQWU7Q0FDOUIsQ0FBQyxDQUNILENBQUM7QUFHVyxRQUFBLFFBQVEsR0FBRztJQUN0QixlQUFlLEVBQUUsSUFBSSwyQkFBaUIsQ0FBQyxpQkFBaUIsRUFBRSxDQUFDLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQyxNQUFNLEVBQUUsS0FBSyxFQUFFLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDO0lBQ3RHLGdCQUFnQixFQUFFLElBQUksMkJBQVksQ0FBQyxrQkFBa0IsQ0FBQztTQUNuRCxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUM7U0FDakQsV0FBVyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLE1BQU0sRUFBRSxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUM7U0FDekMsR0FBRyxFQUFFO0lBQ1IsWUFBWSxFQUFFLElBQUksMkJBQWlCLENBQUMsY0FBYyxFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDLE1BQU0sRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDLE1BQU0sRUFBRSxDQUFDLENBQUM7Q0FDakcsQ0FBQyJ9